export const COLUMN_ROLES = {
  DIMENSION: 'DIMENSION',
  MEASURE: 'MEASURE'
};